import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { FormattedMessage } from "react-intl";

export function TitleBlock(props) {
  const className = `${style.titleBlock} ${props.className}`;

  return (
    <div className={className}>
      <h6 aria-label={props.ariaLabel}>
        <FormattedMessage id={props.title} defaultMessage={props.title} />
      </h6>
      <h5>
        <FormattedMessage id={props.text} defaultMessage={props.text} />
      </h5>
    </div>
  );
}

TitleBlock.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Main Title to display on Header [ NoteBook]
   */
  title: PropTypes.string,
  /**
   * Sub Title to display on Header [ Notebook ]
   */
  text: PropTypes.string,
  /**
   * Aria label to set on Main Tilte [ Notebook ]
   */
  ariaLabel: PropTypes.string,
};

TitleBlock.defaultProps = {
  className: "",
  title: "",
  text: "",
  ariaLabel: "",
};
